// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ingress-target .target[data-v-477d2f1b]:not(:last-child){margin-bottom:5px}", ""]);
// Exports
module.exports = exports;
